import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  addCandidateToRole,
  deleteRole,
  deleteRoles,
  getRole,
  getRolesData,
  importCandidateToRole,
  rejectCandidateFromJob,
} from "api/roles.api";
import { notificationController } from "controllers/notificationController";

export interface RolesSlice {
  roles_data: any;
  roles_loading_status: number;
  roles_details: any;
  import_list_refresher: any;
  role_details_refresher: any;
}

const initialState: RolesSlice = {
  roles_data: null,
  roles_loading_status: 0,
  roles_details: null,
  role_details_refresher: 0,
  import_list_refresher: 0,
};

export const doGetRolesList = createAsyncThunk(
  "roles/doGetRolesList",
  async () =>
    getRolesData().then((res: any) => {
      return res;
    })
);

export const doImportCandidateToRole = createAsyncThunk(
  "roles/doImportCandidateToRole",
  async (roleImportCandidatePayload: any, { dispatch }) =>
    importCandidateToRole(roleImportCandidatePayload).then((res) => {
      dispatch(doGetRolesList());
      dispatch(doGetRoleDetails(roleImportCandidatePayload.job));
      return res;
    })
);

export const doRejectCandidateFromJob = createAsyncThunk(
  "roles/doRejectCandidateFromJob",
  async (rejectCandidatePayload: any, { dispatch }) =>
    rejectCandidateFromJob(rejectCandidatePayload).then((res: any) => {
      dispatch(doGetRolesList());
      // dispatch(doGetRoleDetails(rejectCandidatePayload.jobs[0]));
      return res;
    })
);
export const doGetRoleDetails = createAsyncThunk(
  "roles/doGetRoleDetails",
  async (id: any, { dispatch }) =>
    getRole(id).then((res) => {
      return res;
    })
);

export const doDeleteRole = createAsyncThunk(
  "roles/doDeleteRole",
  async (roleId: any, { dispatch }) => {
    return deleteRole(roleId).then(
      (res) => {
        dispatch(doGetRolesList());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

export const doDeleteRoles = createAsyncThunk(
  "roles/doDeleteRoles",
  async (roleIds: any, { dispatch }) => {
    return deleteRoles(roleIds).then(
      (res) => {
        dispatch(doGetRolesList());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

export const doAddCandidateToRole = createAsyncThunk(
  "roles/doAddCandidateToRole",
  async (payload: any, { dispatch }) =>
    addCandidateToRole(payload).then((res) => {
      return res;
    })
);

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    refreshRoleImportList: (state, action) => {
      state.import_list_refresher = Math.random();
    },
    refreshRoleDetails: (state, action) => {
      state.role_details_refresher = Math.random();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetRolesList.pending, (state, action) => {
      state.roles_loading_status = 1;
    });
    builder.addCase(doGetRolesList.fulfilled, (state, action) => {
      state.roles_data = action.payload;
      state.roles_loading_status = 2;
    });
    builder.addCase(doGetRoleDetails.fulfilled, (state, action) => {
      state.roles_details = action.payload;
    });
  },
});
export const { refreshRoleImportList, refreshRoleDetails } = rolesSlice.actions;
export default rolesSlice.reducer;
